// One registry shared by every surface that can park a thread, so the sidebar,
// the command palette and a thread's own menu invalidate each other's Undo
// instead of each offering to reverse a state the others already moved past.

const currentActions = new Map<string, symbol>();
const listeners = new Set<() => void>();

export function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function notify() {
  for (const listener of listeners) listener();
}

/**
 * Claim one kind of action on one thread. A later claim of the same kind on the
 * same thread expires this one, so an Undo can never reverse a state that has
 * since been changed again.
 */
export function begin(kind: string, threadKey: string) {
  const key = JSON.stringify([kind, threadKey]);
  const token = Symbol();
  currentActions.set(key, token);
  notify();
  const isCurrent = () => currentActions.get(key) === token;
  return {
    isCurrent,
    finish: () => {
      if (isCurrent()) {
        currentActions.delete(key);
        notify();
      }
    },
  };
}

/** Expire only this kind of action on this thread, leaving unrelated ones intact. */
export function invalidate(kind: string, threadKey: string) {
  currentActions.delete(JSON.stringify([kind, threadKey]));
  notify();
}
